'use client';

import { useTranslations } from 'next-intl';
import { toast } from '@/app/components/ui/use-toast';
import { useFetch, useGlobalModal } from '@/app/hooks';
import { inspirationsUnpublishMyInspiration } from '../apis';

export const useUnpublishInspiration = (onSuccess?: (id: string) => void) => {
  const t = useTranslations();
  const { open: openConfirmDialog } = useGlobalModal('confirmDialog');

  const { loading, run: unpublishInspiration } = useFetch(
    (id: string) =>
      inspirationsUnpublishMyInspiration({
        path: { id },
        body: { id },
      }),
    {
      manual: true,
      onSuccess: ({ error }, [id]) => {
        if (error) {
          toast({
            type: 'error',
            message: t('creations.warning.unpublishFailed'),
          });
          return;
        }
        toast({
          message: t('creations.operations.unpublishSuccess'),
        });
        onSuccess?.(id);
      },
    },
  );

  const openUnpublishConfirmDialog = (id: string) => {
    openConfirmDialog({
      title: t('creations.operations.unpublishConfirmTitle'),
      description: t('creations.operations.unpublishConfirmDescription'),
      secondaryButtonText: t('creations.operations.cancel'),
      primaryButtonText: t('creations.operations.unpublish'),
      onPrimaryAction: () => unpublishInspiration(id),
    });
  };

  return {
    loading,
    openUnpublishConfirmDialog,
  };
};
